import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { RequestsService } from '../services/requests.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { Dependent } from '../../../user/models/user-profile.model';

@Component({
  selector: 'app-medica-telefonica',
  imports: [CommonModule, FormsModule, MatIconModule, MatRadioModule, MatIconModule],
  templateUrl: './medica-telefonica.component.html',
  styleUrl: './medica-telefonica.component.scss'
})
export class MedicaTelefonicaComponent {
  @Input() nameService: string = '';

  dependent: Dependent[] = [];
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  selectedPatient = 'titular';
  contactoDeTelefono: String = '0';

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      const clSubServicio = parseInt(this.route.snapshot.queryParams['clSubServicio']);
      const serviceContact = contacts.find((c: any) => c.clSubServicio === clSubServicio);
      this.contactoDeTelefono = serviceContact?.phone || '0';
    } catch {
      this.contactoDeTelefono = '0';
    }
  }

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private requestServ: RequestsService, private loader: LoaderService) { }

  ngOnInit():void{
    this.getServiceContact();
    this.getDetailUser();
  }

  getDetailUser() {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
    }

    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.dependent = res.dependents;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  confirm():void{
    this.generateExpediente();
  }

  generateExpediente() {
    const solicitudData = localStorage.getItem('solicitudData');
    let servicio;
    
    if (solicitudData) {
      servicio = JSON.parse(solicitudData).servicio;
    } else {
      const params = this.route.snapshot.queryParams;
      servicio = {
        clServicio: params['clServicio'] || 4,
        clSubservicio: params['clSubServicio'] || 225,
        dsServicio: params['dsServicio'] || 'Asistencia Médica',
        dsSubServicio: params['dsSubServicio'] || 'Consultoría Médica Telefónica'
      };
    }
    
    this.loader.show();
    
    const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
    const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
    const { firstName: ownerFirstName, lastName: ownerLastName, secondLastName: ownerSecondLastName } = this.splitFullName(this.nameOwner);
    
    const accountData = localStorage.getItem('account');
    const accountId = accountData ? JSON.parse(accountData) : 536;
    
    const payload = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        serviceId: servicio.clServicio,
        subServiceId: servicio.clSubservicio.toString(),
        hasAssistance: false,
        key: this.keyOwner,
        areaCode1: '044',
        phone1: this.phoneOwner,
        stateCode: '',
        municipalityCode: '',
        statusId: 0,
        accountId: accountId,
        appUserId: 1,
        countryId: 115,
        contactTypeId: 15,
        serviceTypeId: 1,
        sendCharge: false,
        hasAppointment: false,
        isRelevant: false,
        gender: 1,
        isOk: true,
        hasQuotation: false,
        isSise2: true,
        serviceReceptionId: 10,
        personId: 1,
        username: firstName,
        paternalSurname: lastName,
        userSecondLastName: secondLastName,
        contactName: selectedName,
        userFirstNamePf: ownerFirstName,
        userLastNamePf: ownerLastName,
        userSecondLastNamePf: ownerSecondLastName,
        ourUser: this.nameOwner,
        externalCabRepName: 'API CLIENTES',
        folio: crypto.randomUUID(),
        longitude: '', // Vacío
        latitude: '', // Vacío
        incidentDescription: `Consultoría médica telefónica`,
        clRecepcionServicio: 10
      }
    };

    this.requestServ.sendMedicaTelefonicaRequest(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        console.log('Expediente generado:', res);
        
        const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
        
        const assistanceData = {
          clave: res.response.clave || '',
          clexpediente: expediente,
          nuestrousuario: res.response.nuestrousuario || this.nameOwner,
          clcuenta: res.response.clcuenta || '',
          nombre: 'CONSULTORÍA MÉDICA TELEFÓNICA',
          clservicio: res.response.clservicio || servicio.clServicio,
          dsservicio: servicio.dsServicio || 'Asistencia Médica',
          clsubservicio: res.response.clsubservicio || servicio.clSubservicio,
          dssubservicio: servicio.dsSubServicio || 'Consultoría Médica Telefónica',
          clestatus: res.response.clestatus || '0',
          dsestatus: 'Abierto',
          fecharegistro: res.response.fecharegistro || new Date().toISOString()
        };
        
        if (solicitudData) {
          localStorage.removeItem('solicitudData');
        }
        
        const navigationExtras: NavigationExtras = {
          state: assistanceData,
          queryParams: assistanceData
        };
        
        this.router.navigate(['/solicitud/detalle/', expediente], navigationExtras).then(() => {
          setTimeout(() => {
            this.goToCall();
          }, 1000);
        });
      },
      error: (err) => {
        this.loader.hide();
        console.error('Error al generar expediente:', err);
      }
    });
  }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(/\s+/).filter(p => p);
    if (parts.length <= 1) return { firstName: parts[0] || '', lastName: '', secondLastName: '' };
    if (parts.length === 2) return { firstName: parts[0], lastName: parts[1], secondLastName: '' };
    if (parts.length === 3) return { firstName: parts[0], lastName: parts[1], secondLastName: parts[2] };
    // Para nombres con 4 o más partes, asumir que los primeros 2 son nombres y los últimos 2 son apellidos
    return {
      firstName: parts.slice(0, 2).join(' '),
      lastName: parts[parts.length - 2],
      secondLastName: parts[parts.length - 1]
    };
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }

  goToAddDependent():void{
    this.router.navigate(['add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }

  goToCall() {
    if (this.contactoDeTelefono && this.contactoDeTelefono !== '0') {
      window.open(`tel:${this.contactoDeTelefono}`, '_self');
    }
  }

}
